import {
  AUTH_LOGIN_REQUEST,
  AUTH_LOGIN_FAIL,
  AUTH_LOGIN_SUCCESS,
  AUTH_LOGIN_RESET,
  AUTH_LOGOUT,
  AUTH_RESET_PASSWORD_REQUEST,
  AUTH_RESET_PASSWORD_SUCCESS,
  AUTH_RESET_PASSWORD_FAIL,
  AUTH_RESET_PASSWORD_RESET,
  AUTH_RESET_SEND_RESET_EMAIL_ACCOUNT_REQUEST,
  AUTH_RESET_SEND_RESET_EMAIL_ACCOUNT_SUCCESS,
  AUTH_RESET_SEND_RESET_EMAIL_ACCOUNT_FAIL,
  AUTH_RESET_SEND_RESET_EMAIL_ACCOUNT_RESET,
  AUTH_VERIFY_RESET_PASSWORD_TOKEN_REQUEST,
  AUTH_VERIFY_RESET_PASSWORD_TOKEN_SUCCESS,
  AUTH_VERIFY_RESET_PASSWORD_TOKEN_FAIL,
  AUTH_VERIFY_RESET_PASSWORD_TOKEN_RESET,
  AUTH_UPDATE_PASSWORD_REQUEST,
  AUTH_UPDATE_PASSWORD_SUCCESS,
  AUTH_UPDATE_PASSWORD_FAIL,
  AUTH_UPDATE_PASSWORD_RESET,
  AUTH_VERIFY_LOGIN_CODE_REQUEST,
  AUTH_VERIFY_LOGIN_CODE_SUCCESS,
  AUTH_VERIFY_LOGIN_CODE_FAIL,
  AUTH_VERIFY_LOGIN_CODE_RESET,
  AUTH_SELECT_ACCOUNT_LOGIN_REQUEST,
  AUTH_SELECT_ACCOUNT_LOGIN_SUCCESS,
  AUTH_SELECT_ACCOUNT_LOGIN_FAIL,
  AUTH_SELECT_ACCOUNT_LOGIN_RESET,
  AUTH_GOOGLE_LOGIN_REQUEST,
  AUTH_GOOGLE_LOGIN_SUCCESS,
  AUTH_GOOGLE_LOGIN_FAIL,
  AUTH_GOOGLE_LOGIN_RESET,
  AUTH_SWITCH_TENANT_REQUEST,
  AUTH_SWITCH_TENANT_SUCCESS,
  AUTH_SWITCH_TENANT_FAIL,
  AUTH_SWITCH_TENANT_RESET,
} from "../constants/authConstants";

export const authLoginReducer = (state = {}, action) => {
  switch (action.type) {
    case AUTH_LOGIN_REQUEST:
      return { loading: true };
    case AUTH_LOGIN_SUCCESS:
      return {
        loading: false,
        userInfo: action.payload,
      };
    case AUTH_LOGIN_FAIL:
      return { loading: false, error: action.payload };
    case AUTH_LOGIN_RESET:
      return {};
    case AUTH_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const authGoogleLoginReducer = (state = {}, action) => {
  switch (action.type) {
    case AUTH_GOOGLE_LOGIN_REQUEST:
      return { loading: true };
    case AUTH_GOOGLE_LOGIN_SUCCESS:
      return {
        loading: false,
        userInfo: action.payload,
      };
    case AUTH_GOOGLE_LOGIN_FAIL:
      return { loading: false, error: action.payload };
    case AUTH_GOOGLE_LOGIN_RESET:
      return {};
    default:
      return state;
  }
};

export const authRequestResetPasswordReducer = (state = {}, action) => {
  switch (action.type) {
    case AUTH_RESET_PASSWORD_REQUEST:
      return { loading: true };
    case AUTH_RESET_PASSWORD_SUCCESS:
      return {
        loading: false,
        success: action.payload,
      };
    case AUTH_RESET_PASSWORD_FAIL:
      return { loading: false, error: action.payload };
    case AUTH_RESET_PASSWORD_RESET:
      return {};
    default:
      return state;
  }
};

export const authResetPasswordReducer = (state = {}, action) => {
  switch (action.type) {
    case AUTH_RESET_PASSWORD_REQUEST:
      return { loading: true };
    case AUTH_RESET_PASSWORD_SUCCESS:
      return {
        loading: false,
        success: action.payload,
      };
    case AUTH_RESET_PASSWORD_FAIL:
      return { loading: false, error: action.payload };
    case AUTH_RESET_PASSWORD_RESET:
      return {};
    default:
      return state;
  }
};

export const authSendResetEmailAccountReducer = (state = {}, action) => {
  switch (action.type) {
    case AUTH_RESET_SEND_RESET_EMAIL_ACCOUNT_REQUEST:
      return { loading: true };
    case AUTH_RESET_SEND_RESET_EMAIL_ACCOUNT_SUCCESS:
      return { loading: false, success: action.payload };
    case AUTH_RESET_SEND_RESET_EMAIL_ACCOUNT_FAIL:
      return { loading: false, error: action.payload };
    case AUTH_RESET_SEND_RESET_EMAIL_ACCOUNT_RESET:
      return {};
    default:
      return state;
  }
};

export const authVerifyResetPasswordTokenReducer = (state = {}, action) => {
  switch (action.type) {
    case AUTH_VERIFY_RESET_PASSWORD_TOKEN_REQUEST:
      return { loading: true };
    case AUTH_VERIFY_RESET_PASSWORD_TOKEN_SUCCESS:
      return {
        loading: false,
        success: action.payload,
        singleAccount: action.payload.singleAccount,
        accounts: action.payload.accounts,
      };
    case AUTH_VERIFY_RESET_PASSWORD_TOKEN_FAIL:
      return { loading: false, error: action.payload };
    case AUTH_VERIFY_RESET_PASSWORD_TOKEN_RESET:
      return {};
    default:
      return state;
  }
};

export const authUpdatePasswordReducer = (state = {}, action) => {
  switch (action.type) {
    case AUTH_UPDATE_PASSWORD_REQUEST:
      return { loading: true };
    case AUTH_UPDATE_PASSWORD_SUCCESS:
      return { loading: false, success: action.payload };
    case AUTH_UPDATE_PASSWORD_FAIL:
      return { loading: false, error: action.payload };
    case AUTH_UPDATE_PASSWORD_RESET:
      return {};
    default:
      return state;
  }
};

export const authVerifyLoginCodeReducer = (state = {}, action) => {
  switch (action.type) {
    case AUTH_VERIFY_LOGIN_CODE_REQUEST:
      return { loading: true };
    case AUTH_VERIFY_LOGIN_CODE_SUCCESS:
      return {
        loading: false,
        success: action.payload,
        accounts: action.payload.accounts,
      };
    case AUTH_VERIFY_LOGIN_CODE_FAIL:
      return { loading: false, error: action.payload };
    case AUTH_VERIFY_LOGIN_CODE_RESET:
      return {};
    default:
      return state;
  }
};

export const authSelectAccountLoginReducer = (state = {}, action) => {
  switch (action.type) {
    case AUTH_SELECT_ACCOUNT_LOGIN_REQUEST:
      return { loading: true };
    case AUTH_SELECT_ACCOUNT_LOGIN_SUCCESS:
      return {
        loading: false,
        success: action.payload,
        userInfo: action.payload.userInfo,
      };
    case AUTH_SELECT_ACCOUNT_LOGIN_FAIL:
      return { loading: false, error: action.payload };
    case AUTH_SELECT_ACCOUNT_LOGIN_RESET:
      return {};
    default:
      return state;
  }
};

export const authSwitchTenantReducer = (state = {}, action) => {
  switch (action.type) {
    case AUTH_SWITCH_TENANT_REQUEST:
      return { loading: true };
    case AUTH_SWITCH_TENANT_SUCCESS:
      return {
        loading: false,
        success: action.payload,
        userInfo: action.payload.userInfo,
      };
    case AUTH_SWITCH_TENANT_FAIL:
      return { loading: false, error: action.payload };
    case AUTH_SWITCH_TENANT_RESET:
      return {};
    default:
      return state;
  }
};
